import React from "react";
import {BrowserRouter} from "react-router-dom";
import {SiteRoutes} from "./SiteRoutes";

export const AppRouter = () => {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <SiteRoutes/>
        </BrowserRouter>
    );
};